export default [
	{
		path: '/physicianVisits/consult/:id',
		name: 'physicianVisitsConsult',
		component: () => import('@/views/physician-visits/consult.vue'),
		meta: { title: '填写咨询内容' }
	},
	{
		path: '/physicianVisits/subscribe',
		name: 'physicianVisitsSubscribe',
		component: () => import('@/views/physician-visits/subscribe.vue'),
		meta: { title: '预约咨询' }
	},
	{
		path: '/physicianVisits/scheduleDetail/:id',
		name: 'physicianVisitsScheduleDetail',
		component: () => import('@/views/physician-visits/schedule-detail.vue'),
		meta: { title: '医生详情' }
	},
	{
		path: '/physicianVisits/success/:id',
		name: 'physicianVisitsSuccess',
		component: () => import('@/views/physician-visits/success.vue'),
		meta: { title: '预约成功' }
	},
	{
		path: '/physicianVisits/diagnosis/:id',
		name: 'physicianVisitsDiagnosis',
		component: () => import('@/views/physician-visits/diagnosis.vue'),
		meta: { title: '咨询小结' }
	},
	{
		path: '/physicianVisits/record/:id',
		name: 'physicianVisitsRecord',
		component: () => import('@/views/physician-visits/record.vue'),
		meta: { title: '服务记录' }
	}
]
